module.exports = __webpack_public_path__ + "static/img/d_bg.8f8483ed.png";